class Lang {

    on() {
        EventBus.$emit('loading', true);
    }

    off() {
        EventBus.$emit('loading', false);
    }

}

export default Lang = new Lang()
